import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/gospel',
    name: 'gospel',
    component: () => import('../views/GospelView.vue')
  },
  {
    path: '/fellowship',
    name: 'fellowship',
    component: () => import('../views/FellowshipView.vue')
  },
  {
    path: '/resources',
    name: 'resources',
    component: () => import('../views/ResourcesView.vue')
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('../views/EventsView.vue')
  },
  {
    path: '/events/:slug',
    name: 'event-detail',
    component: () => import('../views/EventDetailView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
